import { z } from 'zod'

export const ZPassportVerificationForm = z.object({
  contactNumber: z
    .string()
    .min(5, '국가 번호를 포함하여 5자 이상 입력해 주세요.'),
  passportImageUrl: z.string(),
})

export type TPassportVerificationForm = z.infer<
  typeof ZPassportVerificationForm
>

export const passportVerificationFormDefaultValues = {
  contactNumber: '',
  passportImageUrl: '',
}
